/**
 * Return only the date component of a ISO 8601 date time string
 * 
 * @param {*} date ISO 8601 format e.g., yyyy-MM-ddTHH:MM:SSZ
 * @returns 
 */
export function dateOnlyISO8601(date: string): string {
  return date.substring(0, date.indexOf('T'));
}
